import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useToast, useAuth, usePage, usePopup } from "@/comn/hooks"; // hook
import {
    URLS,
    APIS,
    SF_BLL_REUS_DTL_SRCH,
    SF_BLL_REUS_DTL,
    SG_BLL_REUS_DTL_BLL_LIST,
    SF_REUS,
    SG_BLL_ITM_LIST,
} from "./services/OsciBllReusService"; // 서비스
import { APIS_COMN, SF_COMN_TANSAD_INFO } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Bill Reus Registration
 * !== 고지 재사용 등록 ==!
 */
export const OSCI0403006S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0023" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams();
    const { mode } = useParams();
    const [searchParams] = useSearchParams();
    const reusRqstSn = searchParams.get("reusRqstSn") || undefined;

    // 폼 처리
    const [isVisibleBll, setIsVisibleBll] = useState(false);
    const [isVisibleReus, setIsVisibleReus] = useState(false);

    // grid 그리기
    const [vsdDtls, setVsdDtls] = useState(false);
    const [vsdItms, setVsdItms] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    // 버튼 처리
    const [isVisibleSaveBtn, setIsVisibleSaveBtn] = useState(false);
    const [isTzs, setTzs] = useState(true);
    const [isCmbn, setCmbn] = useState(true);
    // Amounts, deadline and item amounts can be changed only on a new or still registered (R) request
    // !== 금액·기한·항목 금액은 새 요청이거나 아직 등록(R) 상태인 요청일 때만 바꿀 수 있다 ==!
    const [isEditableReus, setIsEditableReus] = useState(true);
    const [exrt, setExrt] = useState();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Reuse Detail Search !== 고지 재사용 상세 조회 ==!
        bllReusDtlSrch: useForm({
            defaultSchema: SF_BLL_REUS_DTL_SRCH,
            defaultValues: {
                bllMgmtId: bllMgmtId,
                reffKeyNo1: auth.get("cstmCd"),
            },
        }),
        // Bill Reuse Detail  !== 고지 재사용 상세 폼 ==!
        bllReusDtl: useForm({
            defaultSchema: SF_BLL_REUS_DTL,
        }),
        // Common TANSAD Info  !== 공통 TANSAD정보 폼 ==!
        comnTansadInfo: useForm({
            defaultSchema: SF_COMN_TANSAD_INFO,
        }),
        // Reuse  !== 재사용 등록 폼 ==!
        reusForm: useForm({
            defaultSchema: SF_REUS,
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Reuse Detail Bill List !== 고지 재사용 상세화면의 고지목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_BLL_REUS_DTL_BLL_LIST,
        }),
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    /*
     * USD -> TZS 환산 헬퍼 (환율 exrt 기준)
     * !== OSCI0205008S usdToTzs 이식 ==!
     */
    const usdToTzs = (usd: any) => {
        if (!usd || !exrt) return 0;
        return Number((usd * exrt).toFixed(2));
    };

    /*
     * 통화별 편집 가능 토글
     * !== isTzs === true : TZS 통화 / false : USD 통화 (OSCI0205008S readyCurr 이식) ==!
     */
    const readyCurr = (_isTzs: boolean) => {
        if (_isTzs) {
            // TZS : TZS 금액 입력, USD 금액 readonly
            form.bllReusDtl.setSchema("feeAmt", { edit: false });
            form.bllReusDtl.setSchema("feeTzsAmt", { edit: true });
        } else {
            // USD : USD 금액 입력, TZS 금액은 환산(readonly)
            form.bllReusDtl.setSchema("feeAmt", { edit: true });
            form.bllReusDtl.setSchema("feeTzsAmt", { edit: false });
        }
    };

    const readyEdit = (bllReusData: any, editable: boolean) => {
        const _isCmbn = !!bllMgmtId?.startsWith("G") || (bllReusData?.bllDtls?.length ?? 0) > 1;
        if (_isCmbn) {
            setCmbn(true);
            form.bllReusDtl.setSchema("feeAmt", { edit: false });
            form.bllReusDtl.setSchema("feeTzsAmt", { edit: false });
        } else {
            // 통화 판별 후 편집가능 필드 토글 (USD 아니면 TZS)
            const _isTzs = bllReusData.currCd !== "USD";
            setCmbn(false);
            setTzs(_isTzs);
            if (bllReusData.exrt) {
                setExrt(bllReusData.exrt);
                form.bllReusDtl.setValue("exrt", bllReusData.exrt);
            }

            readyCurr(_isTzs);
        }

        // A request already sent or finished (S / F / C) is shown read-only !== 이미 보냈거나 끝난 요청(S / F / C)은 읽기 전용 ==!
        if (!editable) {
            form.bllReusDtl.setSchema("feeAmt", { edit: false });
            form.bllReusDtl.setSchema("feeTzsAmt", { edit: false });
        }
        setIsEditableReus(editable);
        form.bllReusDtl.setSchema("payDdlnDt", { edit: editable });
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getExchageRate: useFetch({
            api: (data) => {
                return APIS.getExchageRate(data);
            },
            enabled: true,
            onSuccess: (data) => {
                if (!data.exrt.content || data.exrt.content === 0) {
                    modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
                } else {
                    setExrt(data.exrt.content);
                    form.bllReusDtl.setValue("exrt", data.exrt.content);
                }
            },
            onError: (error) => {
                modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
            },
        }),
        // Get Bill Reuse Detail !== 고지 재사용 상세 조회 ==!
        getBllReusDtl: useFetch({
            api: (bllNo) => APIS.getBllReusDtl({ ...form.bllReusDtlSrch.getValues(), reusRqstSn }),
            onSuccess: (data) => {
                const bllReusData = data.bllReusDtl.content;
                if (!bllReusData?.bllNo) {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                    return;
                }

                // 컨트롤번호가 없는 경우
                if (!bllReusData?.ctrlNo) {
                    modal.openModal({
                        content: "msg.osc.00268", // There is no information sent to Revenue Gateway. The Notice cannot be canceled.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleReus(false);
                    return;
                }

                // 납부 기한이 지난 경우
                const today = new Date();
                const todayStr =
                    today.getFullYear().toString() +
                    String(today.getMonth() + 1).padStart(2, "0") +
                    String(today.getDate()).padStart(2, "0");
                const isExpired = !!bllReusData?.lastPayDdlnDt && bllReusData.lastPayDdlnDt < todayStr;

                // 취소 안 된 고지인 경우 or 납부기한이 남은 경우
                if (bllReusData?.dspoYn !== "Y" && !isExpired) {
                    modal.openModal({
                        content: "msg.osc.00312", //The bill has been cancelled, or the payment due date has not yet passed.
                        // content: "msg.osc.00282", // The notice has not been cancelled.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleReus(false);
                    return;
                }
                // 이미 납부된 경우
                if (bllReusData?.bllStatCd == "C") {
                    modal.openModal({
                        content: "msg.osc.00168", // Payment received. Notice cannot be cancelled.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleReus(false);
                    return;
                }
                // 진행 중인 재사용 요청(전송 후 ZanMalipo 결과 대기)이 있으면 새로 등록할 수 없다
                if (!reusRqstSn && bllReusData?.lastReusStatCd == "S") {
                    modal.openModal({
                        content: "msg.osc.00333", // A reuse request for this bill is in progress. Please wait for the ZanMalipo result.
                    });
                    setIsVisibleBll(false);
                    setIsVisibleReus(false);
                    return;
                }

                // form 데이터 세팅
                form.bllReusDtl.setValues({
                    ...bllReusData,
                });

                // A request opened from the detail screen (Update) stays editable while it is Registered (R), i.e. not yet sent to ZanMalipo.
                // !== 상세 화면(Update)에서 연 재사용 요청은 등록(R) 상태, 즉 ZanMalipo 전송 전이면 수정할 수 있다. ==!
                const isEditable = !reusRqstSn || bllReusData.reusStatCd === "R";
                readyEdit(bllReusData, isEditable);

                setIsVisibleBll(true);
                setIsVisibleReus(true);

                // Taxpayer TIN
                let pyerMgmtNoNm = "";
                if (bllReusData?.pyerMgmtNo == null || bllReusData?.pyerNm == null) {
                    if (bllReusData?.pyerMgmtNo != null) {
                        pyerMgmtNoNm = bllReusData?.pyerMgmtNo;
                    } else if (bllReusData?.pyerNm != null) {
                        pyerMgmtNoNm = bllReusData?.pyerNm;
                    }
                } else {
                    pyerMgmtNoNm = bllReusData?.pyerMgmtNo + ", " + bllReusData?.pyerNm;
                }
                form.bllReusDtl.setValue("pyerMgmtNoNm", pyerMgmtNoNm);

                // Reference Key
                if (bllReusData.reffKeyTpCd && bllReusData.reffKeyTpCd === "T") {
                    let reffKeyNo =
                        bllReusData?.reffKeyNo1 +
                        "-" +
                        bllReusData?.reffKeyNo2 +
                        (bllReusData?.reffKeyNo3 ? "-" + bllReusData?.reffKeyNo3 : "") +
                        (bllReusData?.reffKeyNo4 ? "-" + bllReusData?.reffKeyNo4 : "");
                    form.bllReusDtl.setValue("reffKey", reffKeyNo);
                } else {
                    let reffKeyNo = bllReusData?.reffKeyNo1;
                    form.bllReusDtl.setValue("reffKey", reffKeyNo);
                }

                // Register
                form.bllReusDtl.setValue("bllRgsrIdNm", bllReusData?.bllRgsrId + ", " + bllReusData?.bllRgsrNm);

                if (bllReusData.reusCd) {
                    form.reusForm.setValue("reusCdSave", bllReusData?.reusCd);
                    form.reusForm.setValue("reusRmrkSave", bllReusData?.reusRmrk);
                }
                if (!reusRqstSn && !bllReusData.reusCd) {
                    form.reusForm.setValue("reusCdSave", "");
                    form.reusForm.setValue("reusRmrkSave", "");
                }
                form.reusForm.setEditable(isEditable);
                setIsVisibleSaveBtn(isEditable);

                if (data.bllReusDtl.content.bllDtls && data.bllReusDtl.content.bllDtls.length > 0) {
                    setVsdDtls(true);
                    setBllDtlList(comnUtils.getGridData(data.bllReusDtl.content.bllDtls));
                }
                if (data.bllReusDtl.content.bllItms && data.bllReusDtl.content.bllItms.length > 0) {
                    setVsdItms(true);
                    setBllItmList(comnUtils.getGridData(data.bllReusDtl.content.bllItms));
                }

                form.bllReusDtlSrch.setValues({
                    ...data.bllReusDtl.content,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Save Bill Reuse !== 고지서 재사용 저장 ==!
        saveBllReus: useFetch({
            api: (dtlData, reusData, mode) => APIS.saveBllReus(dtlData, reusData, mode),
            onSuccess: (data) => {
                // Open the detail of the request just saved !== 방금 저장한 요청의 상세를 연다 ==!
                const savedReusRqstSn = data?.osciBllReusSaveResDto?.content?.reusRqstSn;
                modal.openModal({
                    content: "msg.osc.00006", // 성공적으로 처리 되었습니다.
                    onClose: () => {
                        let bllTpCd = form.bllReusDtlSrch.getValue("bllTpCd");
                        let bllSysmCd = form.bllReusDtlSrch.getValue("bllSysmCd");
                        let bllYy = form.bllReusDtlSrch.getValue("bllYy");
                        let bllSrno = form.bllReusDtlSrch.getValue("bllSrno");
                        let bllDgr = form.bllReusDtlSrch.getValue("bllDgr");
                        navigate(
                            `${URLS.osci0403005q}/${bllTpCd}${bllSysmCd}${bllYy}${bllSrno}${bllDgr}` +
                                (savedReusRqstSn ? `?reusRqstSn=${savedReusRqstSn}` : ""),
                        );
                        // mode == "INSERT" ? navigate(`${URLS.osci0403004q}`) : navigate(`${URLS.osci0403005q}/${bllNo}`);
                    },
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    console.log(error.response.data);
                }
                // Business errors (e.g. a reuse request in progress) carry their own message !== 업무 오류(진행 중인 재사용 요청 등)는 서버 메시지를 보여 준다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", // 처리중 문제가 발생하였습니다.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Bill Reuse Registration Detail !== 고지 재사용 등록 상세 조회 ==!
        getBllReusRgsrDtl: () => {
            form.bllReusDtlSrch.handleSubmit(
                () => {
                    let bllNo = form.bllReusDtlSrch.getValue("bllNo");

                    if (bllNo) {
                        bllNo = bllNo.trim(); // 앞뒤 공백 제거

                        // "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거
                        if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(bllNo)) {
                            bllNo = bllNo.replaceAll("-", "");
                        }

                        form.bllReusDtlSrch.setValue("bllNo", bllNo); // 정규화된 값을 폼에 반영
                    }
                    let bllTpCd = form.bllReusDtlSrch.getValue("bllTpCd");
                    let bllSysmCd = form.bllReusDtlSrch.getValue("bllSysmCd");
                    let bllYy = form.bllReusDtlSrch.getValue("bllYy");
                    let bllSrno = form.bllReusDtlSrch.getValue("bllSrno");
                    let bllDgr = form.bllReusDtlSrch.getValue("bllDgr");
                    let bllMgmtIdSrch = form.bllReusDtlSrch.getValue("bllMgmtId");
                    if (
                        !!!bllNo &&
                        !!!bllMgmtIdSrch &&
                        (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)
                    ) {
                        modal.openModal({
                            content: "msg.osc.00182", // Please check Bill No.
                        });
                        setIsVisibleBll(false);
                        setIsVisibleReus(false);
                        return false;
                    }
                    fetch.getBllReusDtl.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // 데이터가 유효하지 않습니다.
                },
            )();
        },
        // Get Processing History List !== 처리 이력 목록 조회 ==!
        getPrcsHistLst: () => {
            let tansadNo = form.comnTansadInfo.getValue("tansadNo");
            tansadNo = colUtils.setMask(tansadNo, "tansadNo");

            // Declaration 처리이력 (팝업)
            popup.openPopup({
                id: "tansadPrcsHistLstPpup",
                url: URLS.clri0801029q,
                params: tansadNo,
                size: "lg",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // Save Bill Reuse !== 고지 재사용 저장 ==!
        saveBllReus: form.reusForm.handleSubmit(
            () => {
                let valid = true;
                const dtlData = { ...form.bllReusDtl.getValues() };
                const reusData = { ...form.reusForm.getValues(), exrt: exrt };

                const dtlGridData = grid.bllDtlList.getData();
                const itmGridData = grid.bllItmList.getData();

                const isCmbn = (dtlGridData?.length ?? 0) > 1;

                // 1. 활성 통화 기준 합계 계산 (TZS : feeTzsAmt / USD : feeAmt)
                const totAmt = Number(isTzs ? dtlData.feeTzsAmt || 0 : dtlData.feeAmt || 0);
                const totalFeeAmt = dtlGridData.reduce(
                    (sum: number, dtl: any) => sum + Number(isTzs ? dtl.feeTzsAmt || 0 : dtl.feeAmt || 0),
                    0,
                );

                // 총합 금액은 0보다 커야 함
                if (totAmt <= 0) {
                    modal.openModal({ content: "msg.osc.00089" }); // The amount must be greater than 0.
                    return;
                }

                // 통합고지서 : 총액 = 상세고지서 합계
                if (isCmbn) {
                    // 총액 검증
                    if (Number(totAmt || 0) !== totalFeeAmt) {
                        const msg = t("msg.osc.00054", { 0: `the amount.` });
                        modal.openModal({ content: msg });
                        valid = false;
                    }

                    if (valid) {
                        // 2. itmGridData를 bllMgmtId별로 그룹핑하여 합계 계산 (활성 통화 기준)
                        const itmAmtMap = itmGridData.reduce((acc: Record<string, number>, itm: any) => {
                            acc[itm.bllMgmtId] =
                                (acc[itm.bllMgmtId] || 0) + Number(isTzs ? itm.bllItmTzsAmt || 0 : itm.bllItmAmt || 0);
                            return acc;
                        }, {});

                        // 3. dtlGridData와 비교 (활성 통화 기준)
                        const hasMismatch = dtlGridData.some((dtl: any) => {
                            const feeAmt = Number(isTzs ? dtl.feeTzsAmt || 0 : dtl.feeAmt || 0);
                            const itmAmt = itmAmtMap[dtl.bllMgmtId] || 0;

                            return feeAmt !== itmAmt;
                        });

                        if (hasMismatch) {
                            const msg = t("msg.osc.00054", { 0: `the item amounts.` });
                            modal.openModal({ content: msg });
                            valid = false;
                            return;
                        }
                    }
                } else {
                    // 일반고지서 : 총액 = 품목금액 합계 (활성 통화 기준)
                    const totalItmAmt = (itmGridData || []).reduce(
                        (sum: number, itm: any) => sum + Number(isTzs ? itm.bllItmTzsAmt || 0 : itm.bllItmAmt || 0),
                        0,
                    );

                    if (totAmt !== totalItmAmt) {
                        const msg = t("msg.osc.00054", { 0: "the item amounts." });
                        modal.openModal({ content: msg });
                        valid = false;
                    }
                }
                const today = new Date();
                const payDdlnDate = new Date(dtlData.payDdlnDt);
                if (valid && payDdlnDate < today) {
                    const msg = t("msg.osc.00313"); // The payment due date must be set to a date after today.
                    modal.openModal({ content: msg });
                    valid = false;
                }

                if (valid) {
                    if (isCmbn) {
                        const dtlList = dtlData.bllDtls;

                        dtlList.forEach((dtl: any) => {
                            const gridItem = dtlGridData.find((item) => item.bllMgmtId === dtl.bllMgmtId);
                            if (gridItem) {
                                dtl.feeAmt = gridItem.feeAmt;
                                dtl.feeTzsAmt = gridItem.feeTzsAmt;
                            }
                        });
                    } else {
                        // 일반고지서 : 상세고지서 bllMgmtId = 고지서 bllMgmtId, top form 금액을 단일 상세에 반영
                        const dtlList = dtlData.bllDtls;
                        if (dtlList && dtlList.length > 0) {
                            dtlList.forEach((dtl: any) => {
                                dtl.feeAmt = dtlData.feeAmt;
                                dtl.feeTzsAmt = dtlData.feeTzsAmt;
                            });
                        }
                    }

                    const itmList = dtlData.bllItms;

                    itmList.forEach((itm: any) => {
                        const gridItem = itmGridData.find(
                            (item) => item.bllMgmtId === itm.bllMgmtId && item.gfsCd === itm.gfsCd,
                        );
                        if (gridItem) {
                            itm.bllItmAmt = gridItem.bllItmAmt;
                            itm.bllItmTzsAmt = gridItem.bllItmTzsAmt;
                        }
                    });

                    var save_mode = mode;

                    if (dtlData.reusStatCd == "R") {
                        save_mode = "UPDATE";
                    }

                    modal.openModal({
                        content: "msg.osc.00090", // 저장 하시겠습니까 ?
                        onConfirm: () => {
                            fetch.saveBllReus.fetch(dtlData, reusData, save_mode);
                        },
                    });
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    const render = {
        grid_bllDtlList: {
            cell: {
                // 상세고지 USD 금액 : USD 통화일 때만 입력, 입력 시 TZS 자동 환산
                feeAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.feeAmt}
                                onChange={(v) => {
                                    !isTzs &&
                                        grid.bllDtlList.updateRow({
                                            ...rowValues,
                                            feeAmt: v,
                                            feeTzsAmt: usdToTzs(v),
                                        });
                                }}
                                edit={isEditableReus && !isTzs && !isCmbn}
                                required={true}
                            />
                        </>
                    );
                },
                // 상세고지 TZS 금액 : TZS 통화일 때만 입력, USD 칸은 동일값
                feeTzsAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.feeTzsAmt}
                                onChange={(v) => {
                                    isTzs &&
                                        grid.bllDtlList.updateRow({
                                            ...rowValues,
                                            feeAmt: v,
                                            feeTzsAmt: v,
                                        });
                                }}
                                edit={isEditableReus && isTzs && !isCmbn}
                                required={true}
                            />
                        </>
                    );
                },
            },
        },
        grid_bllItmList: {
            head: {},
            cell: {
                // 항목 USD 금액 : USD 통화일 때만 입력, 입력 시 TZS 자동 환산
                bllItmAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmAmt}
                                onChange={(v) => {
                                    !isTzs &&
                                        grid.bllItmList.updateRow({
                                            ...rowValues,
                                            bllItmAmt: v,
                                            bllItmTzsAmt: usdToTzs(v),
                                        });
                                }}
                                edit={isEditableReus && !isTzs && !isCmbn}
                                required={true}
                            />
                        </>
                    );
                },
                // 항목 TZS 금액 : TZS 통화일 때만 입력, USD 칸은 동일값
                bllItmTzsAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmTzsAmt}
                                onChange={(v) => {
                                    isTzs &&
                                        grid.bllItmList.updateRow({
                                            ...rowValues,
                                            bllItmAmt: v,
                                            bllItmTzsAmt: v,
                                        });
                                }}
                                edit={isEditableReus && isTzs && !isCmbn}
                                required={true}
                            />
                        </>
                    );
                },
            },
            edit: {},
        },
    };
    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0403007s}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // 수정인 경우 조회함수 호출
        if (mode == "UPDATE") {
            handler.getBllReusRgsrDtl();
            form.bllReusDtlSrch.setEditable(false);
        }
        form.comnTansadInfo.setEditable(false);
        form.bllReusDtl.setEditable(false);
        // 통화 확정 전에는 두 금액 필드 모두 잠금 → 조회 onSuccess 의 readyCurr(_isTzs)에서 통화별로 제어
        form.bllReusDtl.setSchema("feeAmt", { edit: false });
        form.bllReusDtl.setSchema("feeTzsAmt", { edit: false });
    }, []);

    useEffect(() => {
        if (!isVisibleReus || isCmbn) return;
        readyCurr(isTzs);

        if (isTzs) {
            // TZS: 환산액 = 원금
            const feeAmt = form.bllReusDtl.getValue("feeAmt");
            form.bllReusDtl.setValue("feeTzsAmt", feeAmt);
            grid.bllDtlList
                .getData()
                .forEach((row: any) => grid.bllDtlList.updateRow({ ...row, feeTzsAmt: row.feeAmt }));
            grid.bllItmList
                .getData()
                .forEach((row: any) => grid.bllItmList.updateRow({ ...row, bllItmTzsAmt: row.bllItmAmt }));
        } else {
            // USD: 현재 exrt로 재환산
            const feeAmt = form.bllReusDtl.getValue("feeAmt");
            form.bllReusDtl.setValue("feeTzsAmt", usdToTzs(feeAmt));
            grid.bllDtlList
                .getData()
                .forEach((row: any) => grid.bllDtlList.updateRow({ ...row, feeTzsAmt: usdToTzs(row.feeAmt) }));
            grid.bllItmList
                .getData()
                .forEach((row: any) => grid.bllItmList.updateRow({ ...row, bllItmTzsAmt: usdToTzs(row.bllItmAmt) }));
        }
    }, [isTzs, exrt, isCmbn]);
    return (
        <Page>
            {/* 고지 재사용 상세 조회 */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtlSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllReusDtlSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Col>
                                {/* 고지번호 */}
                                <Group.Control
                                    {...form.bllReusDtlSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllReusDtlSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllReusDtlSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllReusDtlSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllReusDtlSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllReusDtlSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllDgr} />
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>
                    {mode == "INSERT" && (
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllReusDtlSrch.reset();
                                        setIsVisibleBll(true);
                                        form.bllReusDtl.reset();
                                        form.comnTansadInfo.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllReusRgsrDtl();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
            {/* 고지 상세내역 */}
            {isVisibleBll && (
                <>
                    {/* Bill */}
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.bllNo} />
                                    <Group.Control {...form.bllReusDtl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.ctrlNo} />
                                    <Group.Control {...form.bllReusDtl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.currCd} />
                                    <Group.Control {...form.bllReusDtl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control
                                        {...form.bllReusDtl.schema.feeAmt}
                                        onChange={(v: any) => {
                                            // USD : 입력값 x 환율로 TZS 자동 환산
                                            if (!isTzs) {
                                                form.bllReusDtl.setValue("feeTzsAmt", usdToTzs(v));
                                            }
                                        }}
                                    />
                                    <Group.Control
                                        {...form.bllReusDtl.schema.feeTzsAmt}
                                        onChange={(v: any) => {
                                            // TZS : USD 칸은 동일값 저장
                                            if (isTzs) {
                                                form.bllReusDtl.setValue("feeAmt", v);
                                            }
                                        }}
                                    />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.pyerMgmtNo} />
                                    <Group.Control {...form.bllReusDtl.schema.payDdlnDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllReusDtl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.bllRgsrId} />
                                </Group.Row>
                                {/* <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.lastDdlnXtnsDt} />
                                    <Group.Control {...form.bllReusDtl.schema.xtnsDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.lastDdlnXtnsRsn} />
                                </Group.Row> 
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.reusDt} />
                                    <Group.Control {...form.bllReusDtl.schema.reusCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllReusDtl.schema.reusRmrk} />
                                </Group.Row>*/}
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </>
            )}
            {vsdDtls && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                    </Group.Body>
                </Group>
            )}
            {vsdItms && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                    </Group.Body>
                </Group>
            )}
            {/* 고지재사용 등록 */}
            {isVisibleReus && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"T_REUS"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.reusForm.schema.reusCdSave} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.reusForm.schema.reusRmrkSave} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0403004q);
                        }}
                    ></Button>
                </Layout.Left>
                {isVisibleSaveBtn && (
                    <Layout.Right>
                        <Button
                            role="save"
                            onClick={() => {
                                handler.saveBllReus();
                            }}
                        ></Button>
                    </Layout.Right>
                )}
            </Layout>
        </Page>
    );
};
